import type { ReactNode } from "react"

import { cn } from "../../lib/utils"

type SectionContainerProps = {
  children: ReactNode
  className?: string
  id?: string
}

export function SectionContainer({
  children,
  className,
  id,
}: SectionContainerProps) {
  return (
    <section id={id} className={cn("mx-auto w-full max-w-6xl px-4 py-16 md:py-24", className)}>
      {children}
    </section>
  )
}
